import React, { useState, useEffect } from "react";
import { fetchData } from "../Components/common/utils";
import MainLoader from "../Components/MainLoader";
import { Link, NavLink, useLocation, useParams } from "react-router-dom";

function ServicesOnlyDetail() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [pageDetail, setPageDetail] = useState({});

  useEffect(() => {
    const fetchApiData = async () => {
      setLoading(true);
      const url = "api/shops/" + id;
      const result = await fetchData(url);
      setLoading(false);

      if (result && result.data) {
        if (result.data.length >= 1) {
          setPageDetail(result.data[0]);
        } else {
          setPageDetail({}); // no content
        }
      } else {
        setPageDetail({});
      }
    };
    fetchApiData();
  }, [id, location.key]);

  const isEmpty = Object.keys(pageDetail).length === 0;

  return (
    <div className="container">
      {loading && <MainLoader />}

      {!loading && isEmpty && (
        <div className="text-center my-5">
          <h3 className="text-muted">No content found for this page</h3>
        </div>
      )}

      {!loading && !isEmpty && (
        <>
          <div className="mt-4">
            <div className="brand-banner py-3 px-3 text-center text-white mb-4">
              <h1 className="display-4 fw-bold mb-2">
                <span className="brand-name">{pageDetail?.category?.title}</span>
              </h1>
              <p className="lead">{pageDetail?.category?.description}</p>
            </div>
          </div>
          <div
            dangerouslySetInnerHTML={{ __html: pageDetail.long_description }}
            className="my-5"
          />
        </>
      )}
    </div>
  );
}

export default ServicesOnlyDetail;
